












































































/*  eslint-disable @typescript-eslint/no-explicit-any */

import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import SingleText from '@/components/common/elements/SingleText.vue';
import Icon from '@/components/common/elements/Icon.vue';
import Label from '@/components/common/elements/Label.vue';
import Button from '@/components/common/elements/Button.vue';
import MultipleLineText from '@/components/common/elements/MultipleLineText.vue';
import InputArea from '@/components/common/modules/InputArea.vue';
import DatePickerArea from '@/components/common/modules/DatePickerArea.vue';
import ComboBoxArea from '@/components/common/modules/ComboBoxArea.vue';
import SelectArea from '@/components/common/modules/SelectArea.vue';
import IconTextLink from '@/components/common/elements/IconTextLink.vue';
import { TableParameters } from '@/constants/components/table';
import { FieldChildrenProp } from '@/services/hexabase/types';

import AutoCreateForm from '@/components/form/AutoCreateForm.vue';
import ActionButtonWithTablePanel from '@/components/common/modules/ActionButtonWithTablePanel.vue';

//可能な限り外だしする！
interface SelectOptions {
  option_id?: string;
  sort_id?: string;
  value?: string;
  enabled?: true;
  color?: string;
  display_id?: string;
  text?: string;
}

@Component({
  components: {
    SingleText,
    Icon,
    Label,
    Button,
    MultipleLineText,
    InputArea,
    DatePickerArea,
    ComboBoxArea,
    SelectArea,
    AutoCreateForm,
    ActionButtonWithTablePanel,
    IconTextLink
  }
})
export default class CustomerBasicInfoPanel extends Vue {
  @Prop({ default: () => [] })
  private basicFieldData!: Array<FieldChildrenProp>;
  @Prop()
  private basicFieldCols: any;
  @Prop({ default: false })
  private isScrren?: boolean;
  // 表示ステータス
  @Prop({ default: '' })
  private displayStatus!: string;
  // 基本情報パネル開閉アイコン
  private arrowIcon = 'mdi-menu-up';
  private isBasicAreaStatus = true;
  // 親コンポーネントと同期するための値
  @Prop({ default: () => ({}) })
  private parentRegistData: any;
  //サブパネル用のボタンステート
  @Prop({ default: () => [] })
  private statusButton: any;
  // 登録用データ
  private registData: any = {};
  // 画面パネルタイトル
  @Prop({ default: '基本情報' })
  private panelTitle!: string;

  // テーブルに表示するデータ
  @Prop({ default: () => [] })
  private tableParameters?: TableParameters;
  // サブパネル用リスト名
  @Prop({ default: '' })
  private subPnlListName?: string;
  // サブパネル用ラベル
  @Prop({ default: '' })
  private subPnlLabel?: string;

  // サブパネル表示状態制御：登録画面からは無条件false、詳細画面からは条件判定してセット
  @Prop({ default: false })
  private enableSubPanel?: boolean;
  // サブパネル表示状態制御２：監視対象のセレクトボックスが有効な場合のみTrueがセット
  @Prop({ default: false })
  private subpanelState?: boolean;

  // インフォメーションアイコンの設定
  @Prop({ default: '' })
  private displayInfomationMain!: string;
  @Prop({ default: '' })
  private displayInfomationSub!: string;

  private viewSubPnl = false;
  private panelTitleand = '';

  async created() {
    this.panelTitleand = this.panelTitle + 'を';
  }

  /**
   * 基本情報パネルの開閉時の処理
   * 主にCSSの値変更
   * @module toggleBasicArea
   * @return {void} - メンバ変数の変更
   */
  private toggleBasicArea() {
    this.isBasicAreaStatus = !this.isBasicAreaStatus;
    if (this.isBasicAreaStatus) {
      this.arrowIcon = 'mdi-menu-up';
    } else {
      this.arrowIcon = 'mdi-menu-down';
    }
  }

  /**
   * 子コンポーネントからEmitされる値を親に渡す
   * （値が渡されるか確認用）
   * @module catchInput
   * @param {any} response - 子コンポーネントより渡される値
   * @return {void} - Emit
   */
  @Emit('catchInput')
  private catchInput(response: any) {
    if (this.parentRegistData) {
      this.registData = { ...this.parentRegistData };
    }
    let name: any;
    let value: any;
    if (response.type === 'select') {
      name = response.name;
      value = response.value;
      if (
        response.text !== undefined &&
        this.enableSubPanel &&
        this.subpanelState &&
        response.text === '法人'
      ) {
        this.viewSubPnl = true;
      } else if (
        response.text !== undefined &&
        this.enableSubPanel &&
        this.subpanelState &&
        response.text === '個人'
      ) {
        this.viewSubPnl = false;
      }
    } else {
      name = response.name;
      value = response.value;
    }
    // ToDo:フォームのデータタイプに合わせて整形する必要あり
    this.registData[name] = value;
    this.sendData();
    return response;
  }

  /**
   * 子コンポーネントからEmitされた値をインサート・Update用に加工し親に渡す
   * @module sendData
   * @return {void} - Emit
   */
  @Emit('sendData')
  private sendData() {
    return this.registData;
  }
  /** *************************** **/

  /**
   * 子コンポーネント(ActionButtonWithTablePanel)の
   * アクションパネル内で押下したボタン内容を受取
   * @module buttonActionRelay
   * @param  response - 子コンポーネントからのデータ
   * @return response - 子コンポーネントの入力イベント
   */
  @Emit('buttonActionRelay')
  private buttonActionRelay(response: any) {
    return response;
  }

  /**
   * 子コンポーネント(ActionButtonWithTablePanel)の
   * 表内で押下した行の内容を受取
   * @module clickButtonRelay
   * @param  response - 子コンポーネントからのデータ
   * @return response - 子コンポーネントの入力イベント
   */
  @Emit('clickButtonRelay')
  private clickButtonRelay(response: any) {
    return response;
  }

  /**
   * 子コンポーネント(ActionButtonWithTablePanel)の
   * 表内で入力した項目の内容を受取
   * @module getData
   * @param  response - 子コンポーネントからのデータ
   * @return response - 子コンポーネントの入力イベント
   */
  @Emit('getDataRelay')
  private getDataRelay(response: any) {
    return response;
  }

  /**
   * 子コンポーネント(ActionButtonWithTablePanel)の
   * 表内で押下した行の内容を受取
   * @module clickRowOpratiponRelay
   * @param  response - 子コンポーネントからのデータ
   * @return response - 子コンポーネントの入力イベント
   */
  @Emit('clickRowOpratiponRelay')
  private clickRowOpratiponRelay(response: any) {
    return response;
  }

  /**
   * サブパネルの初期表示をコントロール
   */
  public initSubPanel(flg1: boolean, flg2: boolean) {
    //サブパネルの初期表示をコントロール
    if (flg1 && flg2) {
      this.viewSubPnl = true;
    } else {
      this.viewSubPnl = false;
    }
  }

  /**
   * 住所の自動入力
   */
  private getAddress(data: any) {
    if (data !== null) {
      if (data.length > 0) {
        const addressData = data[0];
        Object.keys(addressData).forEach((key: string) => {
          let targetColumnName = '';
          switch (key) {
            case 'address1':
              targetColumnName = 'prefectures';
              break;
            case 'address2':
              targetColumnName = 'municipalities';
              break;
            case 'address3':
              targetColumnName = 'machimura_street_address';
              break;
            case 'kana1':
            case 'kana2':
            case 'kana3':
            case 'prefcode':
            case 'zipcode':
            default:
              return true;
          }
          // Applied to data for register
          this.registData[targetColumnName] = addressData[key];
          // Applied to view's data
          const targetIndex = this.basicFieldData.findIndex((fieldData: any) => fieldData.display_id === targetColumnName);
          if (targetIndex > -1) {
            this.$set(this.basicFieldData[targetIndex].props!, 'value', addressData[key]);
          }
        });
      }
      this.sendData();
    }
  }
}

/*  eslint-enable */
